import axios from "axios";
const publicUrl = process.env.PUBLIC_URL;
export const checkUserStatusAndRedirect = async () => {
  try {
    // Fetch user data from the "user" endpoint
    const res: any = await axios.get(`${publicUrl}/api/user`);
    if (!res) {
      console.error("User data is undefined or null.");
      return;
    }
    console.log("USER RESPONSE from common ===>", res);

    // Fetch user status from the "/school/users/464" endpoint
    const res2: any = await axios.get(`${publicUrl}/api/school/users/${res?.data?.id}`);
    if (!res2) {
      console.error("User status data is undefined or null.");
      return;
    }

    // If status is true, redirect to /logout
    if (res2?.data?.user?.status === false) {
     
      await axios.post(`${publicUrl}/api/logout`);
        window.location.href = "/logout";
        console.log("logged out sucessfully.")
    }
  } catch (error) {
    console.error("Error occurred during the API calls:", error);
  }
};



// WEBPACK FOOTER //
// ./src/api/types/commonLogout.ts